module.exports = __webpack_public_path__ + "static/media/code.8917ba17.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/code.png
// module id = 121
// module chunks = 0